import React from 'react';
import Link from '../../Link';

const MobileHeaderLinks = (props) => {
  const { menuVisible } = props;
  return (
    <ul
      className={`mobile-menu-header-links ${
        menuVisible ? 'mobile-menu-header-links--hidden' : ''
      }`}
    >
      <li>
        <Link to="/power-outages-and-emergencies/live-outage-map/">Outages</Link>
      </li>
      <li>
        <Link to="/contact-us/">Contact</Link>
      </li>
    </ul>
  );
};

export default MobileHeaderLinks;
